import { gql } from '@apollo/client'

// ─── Template fragment ────────────────────────────────────────────────────────

const TWILIO_TEMPLATE_FIELDS = gql`
  fragment TwilioTemplateFields on TwilioWhatsAppTemplateType {
    contentSid
    friendlyName
    language
    approvalStatus
    contentType
    body
    variables
    isActive
    isArchived
    allowedModules
    variableMapping
    llmDescription
    llmTags
    llmInvocable
    lastSyncedAt
    createdAt
    updatedAt
  }
`

// ─── Queries ──────────────────────────────────────────────────────────────────

export const GET_TWILIO_WHATSAPP_TEMPLATES = gql`
  query TwilioWhatsappTemplates($approvalStatus: String, $llmInvocable: Boolean) {
    twilioWhatsappTemplates(approvalStatus: $approvalStatus, llmInvocable: $llmInvocable) {
      ...TwilioTemplateFields
    }
  }
  ${TWILIO_TEMPLATE_FIELDS}
`

export const GET_TWILIO_SYNC_PREVIEW = gql`
  query TwilioSyncPreview {
    twilioSyncPreview {
      unchangedCount
      totalRemote
      newTemplates {
        contentSid
        friendlyName
        language
        approvalStatus
        contentType
        body
      }
      changedTemplates {
        contentSid
        friendlyName
        diffFields
        localSnapshot
        remoteSnapshot
      }
    }
  }
`

export const GET_TWILIO_LLM_TOOLS = gql`
  query TwilioLlmTools {
    twilioLlmTools {
      contentSid
      friendlyName
      language
      llmDescription
      llmTags
      llmInvocable
      llmToolDict
      variables
    }
  }
`
